export default __webpack_public_path__ + "static/media/Star.041f838b.svg";